import { Injectable } from '@angular/core';

declare let moment: any;

@Injectable()
export class TimezoneService {
  timezones: any[] = [];

  constructor() {
    this._buildTimezones();
  }

  _buildTimezones() {
    const timezoneNames = moment.tz.names();
    for (const key in timezoneNames) {
      if (timezoneNames.hasOwnProperty(key)) {
        this.timezones.push({
          key: timezoneNames[key],
          name: timezoneNames[key].replace(/_/g, ' ')
        });
      }
    }
  }

  getAllTimezones(): any[] {
    return this.timezones;
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/timezones.service.ts